import { Password } from '@mui/icons-material';
import { Api, ApiCrib } from '../api';
import { ILoginFormData, ICrtlAcessResponse, IResponseError, IChangePassword } from 'shared/types';
import {IListItemMenuProps} from 'shared/types/crtlAcess';

const login = async (loginData: ILoginFormData): Promise<ICrtlAcessResponse & IResponseError | Error> => {
  try {


    const body = JSON.stringify({
      usuario: loginData.username,
      senha: loginData.password,
    });

    const { data, status } = await Api.post('/CtrlAcesso/login', body);
    //const data: ICrtlAcessResponse & IResponseError = result.data;
    if (data) {
      const { token, erro } = data;
      if (token) {
        Api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return data;
      }
      if (erro) {
        return data;
      }
    }
    return new Error('Erro na validacao do usuário');
  } catch (err) {
    return new Error((err as { message: string }).message || 'Erro ao validar o usuário.');
  }
};
const loginCrib = async (loginData: ILoginFormData): Promise<ICrtlAcessResponse & IResponseError | Error> => {
  try {


    const body = JSON.stringify({
      usuario: loginData.username,
      senha: loginData.password,
    });

    const { data, status } = await ApiCrib.post('/CtrlAcesso/login', body);
    //const data: ICrtlAcessResponse & IResponseError = result.data;
    if (data) {
      const { token, erro } = data;
      if (token) {
        ApiCrib.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return data;
      }
      if (erro) {
        return data;
      }
    }
    return new Error('Erro na validacao do usuário');
  } catch (err) {
    return new Error((err as { message: string }).message || 'Erro ao validar o usuário.');
  }
};

const loginToken = async (novoToken: string): Promise<ICrtlAcessResponse & IResponseError | Error> => {
  try {

    Api.defaults.headers.common['Authorization'] = `Bearer ${novoToken}`;

    const { data, status } = await Api.get('/CtrlAcesso/validatoken');
    //const data: ICrtlAcessResponse & IResponseError = result.data;
    if (data) {
      const { token, erro } = data;
      if (token) {
        Api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return data;
      }
      if (erro) {
        return data;
      }
    }
    return new Error('Erro na validacao do token');
  } catch (err) {
    return new Error((err as { message: string }).message || 'Erro ao validar o token.');
  }
};

const getMenu = async (): Promise<IListItemMenuProps[] | Error> => {
  try {
    const { data, status } = await Api.get('/CtrlAcesso/menu');
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar o menu.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar o menu.');
  }
};

const changePw = async (id:number,password:string): Promise<void | Error>  => {
  try {
    const { data, status } = await Api.put(`/Usuarios/Usuario/${id}/${password}` );
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const changeNewPw = async (id:number,password:string,ant_password:string): Promise<void | Error>  => {
  try {
    const encodedPassword = encodeURIComponent(password);
    const encodedAntPassword = encodeURIComponent(ant_password);
    const { data, status } = await Api.put(`/Usuarios/Usuario/SenhaLogado/${id}/${encodedPassword}/${encodedAntPassword}` );
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};


export const CrtlAcessService = {
  login,
  loginCrib,
  loginToken,
  getMenu,
  changePw,
  changeNewPw
  
};
